import React from 'react';
export function Hero() {
  return <section className="relative w-full h-[600px]" data-id="element-231">
      {/* Full-width background image */}
      <div className="absolute inset-0 w-full h-full" data-id="element-232">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/7zJG2vKgDytLrTDL487fmd/special_performances.png" alt="Musician with special needs performing on stage at a theater" className="w-full h-full object-cover" data-id="element-233" />
        {/* Dark gradient overlay for better text readability */}
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 to-black/30" data-id="element-234"></div>
      </div>
      {/* Content positioned over the image */}
      <div className="relative z-10 h-full flex items-center" data-id="element-235">
        <div className="container mx-auto px-4" data-id="element-236">
          <div className="max-w-xl" data-id="element-237">
            {/* Pill-shaped splash */}
            <div className="inline-block bg-indigo-600 text-white px-4 py-1 rounded-full text-sm font-medium mb-4" data-id="element-238">
              Attention Burlington & Camden County
            </div>
            <h1 className="text-4xl md:text-5xl font-bold mb-6 leading-tight text-white [text-shadow:_0_1px_2px_rgba(0,0,0,0.8)]" data-id="element-239">
              Music That Celebrates Every Musician              
            </h1>
            <p className="text-xl mb-8 text-white [text-shadow:_0_1px_2px_rgba(0,0,0,0.8)]" data-id="element-240">
              We're planning a music collective for adult musicians with autism
              and I/DD. Do you want to join us?
            </p>
            <div className="flex flex-col sm:flex-row gap-4" data-id="element-241">
              <a href="#contact" className="bg-indigo-600 text-white hover:bg-indigo-700 px-8 py-3 rounded-md font-medium text-center transition-colors" data-id="element-242">
                Express Interest
              </a>
              <a href="#about" className="bg-white text-indigo-700 hover:bg-indigo-50 border border-white px-8 py-3 rounded-md font-medium text-center transition-colors" data-id="element-243">
                Learn More
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}